// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2242":"e3ff1e91","3776":"31d6cfe0"}[chunkId] + ".chunk.css";
};